module.exports = __webpack_public_path__ + "img/cabaret_poulet.7ecede26.jpg";